var _path, _circle, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRealmodel = function SvgRealmodel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    d: "M8 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 2.25,
    stroke: "#4C4C4C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    d: "M16.5 19.5c0-2.21-2.015-4-4.5-4s-4.5 1.79-4.5 4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.5,
    height: 2.5,
    x: 7.75,
    y: 2.75,
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    rx: 1.25
  })));
};
export default SvgRealmodel;